export default "__VITE_ASSET__4XJC7egX__"